import { useRouter } from 'next/navigation';
import Button from '../../atoms/Button';
import Heading from '../../atoms/Heading';
import * as S from './styles';
import { Fragment } from 'react';

export type HeaderMenuLateralDeslogadoProps = {
  $lidarMenuLateral: () => void;
};

export default function HeaderMenuLateralDeslogado(
  props: HeaderMenuLateralDeslogadoProps,
) {
  const { $lidarMenuLateral } = props;
  const router = useRouter();

  return (
    <Fragment>
      <Heading
        $priority={4}
        $size={4}
        $color="neutral"
        $weight="bold"
        $align="center"
        $highContrast={true}
        $text="Acesse ou cadastre-se"
      />
      <S.Botoes>
        <Button
          $size={2}
          $variant="solid"
          $color="accent"
          $highContrast={false}
          $loading={false}
          $focusRing={false}
          $text="Acessar"
          $onClick={() => {
            $lidarMenuLateral();
            return router.push('/logar');
          }}
        />
        <Button
          $size={2}
          $variant="soft"
          $color="accent"
          $highContrast={false}
          $loading={false}
          $focusRing={false}
          $text="Cadastrar"
          $onClick={() => {
            $lidarMenuLateral();
            return router.push(`/cadastrar?voltar-home`, { scroll: true });
          }}
        />
      </S.Botoes>
    </Fragment>
  );
}
